import { render, staticRenderFns } from "./chuanShaList.vue?vue&type=template&id=130a31f6&"
import script from "./chuanShaList.vue?vue&type=script&lang=js&"
export * from "./chuanShaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports